import { HttpErrorResponse } from '@angular/common/http';
import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { HTTPService } from 'src/app/main/services/HTTPService';
import CONFIG from 'src/app/main/urls/urls';

@Component({
  selector: 'app-add-catalog-copy',
  templateUrl: './add-catalog-copy.component.html',
  styleUrls: ['./add-catalog-copy.component.css']
})
export class AddCatalogCopyComponent implements OnInit {
  @Output() closeModalEvent = new EventEmitter<void>();

  copyForm: FormGroup;
  books: any[] = [];
  submitted = false;
  loading = false;

  constructor(
    private fb: FormBuilder,
    private httpService: HTTPService,
    private toastr: ToastrService
  ) {}

  ngOnInit(): void {
    this.copyForm = this.fb.group({
      bookId: ['', Validators.required],
      quantity: [1, [Validators.required, Validators.min(1), Validators.max(9999)]]
    });

    // Load all books for the dropdown
    this.httpService.getAll(CONFIG.URL_BASE + '/book/all').subscribe(
      (data: any[]) => {
        this.books = data;
      },
      (err: HttpErrorResponse) => {
        this.toastr.error('Failed to load books: ' + err.message, 'Error');
      }
    );
  }

  get f() {
    return this.copyForm.controls;
  }

  closeModal() {
    this.closeModalEvent.emit();
  }

  onSubmit(): void {
    this.submitted = true;

    if (this.copyForm.invalid) {
      return;
    }

    const { bookId, quantity } = this.copyForm.value;
    this.loading = true;

    this.httpService
      .put(CONFIG.URL_BASE + `/book/${bookId}/quantity/${quantity}`)
      .subscribe(
        () => {
          this.loading = false;
          this.toastr.success('Copies updated successfully!', 'Success');
          this.copyForm.reset({ bookId: '', quantity: 1 });
          this.submitted = false;
          this.closeModal();
        },
        (err: HttpErrorResponse) => {
          this.loading = false;
          this.toastr.error('Failed to update copies: ' + err.message, 'Error');
        }
      );
  }

  onCancel(): void {
    this.closeModal();
  }

  // Helper: show selected book's current quantity if available
  get selectedBook(): any {
    const id = this.copyForm.get('bookId').value;
    return id ? this.books.find(b => b.id == id) : null;
  }
}